import DeliveryRouteList from '../../../../components/Purchasing/Cargo/Routes/DeliveryRouteList'
import DeliveryRouteModal from '../../../../components/Purchasing/Cargo/Routes/DeliveryRouteModal'

import React, { Fragment } from 'react'

function DeliveryRoute(props) {
  return (
    <Fragment>
      <DeliveryRouteModal {...props} />
      <DeliveryRouteList {...props} />
    </Fragment>
  )
}

export default DeliveryRoute
